import { Tab } from '../types';
import { CurrentContext } from '../types/currentContext';
import { AnalyticsContext } from './types';

export const getContextForAnalytics = (
  currentContext: CurrentContext,
  tabName: Tab,
): AnalyticsContext => {
  const { selectedProvider, encounterId } = currentContext;
  return {
    tabName,
    vim_insurer: currentContext.patient?.insurance?.insurer,
    initialContext: {
      selectedProvider: {
        npi: selectedProvider?.npi,
        firstName: selectedProvider?.demographics?.firstName,
        lastName: selectedProvider?.demographics?.lastName,
      },
      encounterId,
    },
  };
};

export const getContentSupplierId = (context: CurrentContext) => {
  const { patient } = context;
  return patient?.patientSourceVaultToken;
};
